import { render, staticRenderFns } from "./PositionAvatar.vue?vue&type=template&id=073003ae"
import script from "./PositionAvatar.vue?vue&type=script&lang=js"
export * from "./PositionAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports